<template>
	<div>
		<div>
			<div style="display: flex; justify-content: space-between">
			</div>
		</div>
		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="orderList" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column type="selection" align="center" width="44"></el-table-column>

				<el-table-column prop="name" label="推送平台名称" width="200" align="center"></el-table-column>
				<el-table-column prop="destinationAuthCode" label="推送授权码 " align="center"></el-table-column>
				<el-table-column prop="pushType" label="推送类型 " align="center"></el-table-column>
				<el-table-column prop="createdTime" label="创建时间" width="120" align="center"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button @click="showSettingDialog(scope.row)">配置站点</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px">
			<div style="height: 40vh; overflow: auto">
				<!-- <el-form :model="orderForm" ref="orderDetail" label-position="right" label-width="620px"> -->
					<el-col :span="22">
						<el-select style="width: 85%" multiple filterable v-model="orderForm.stationIds"
							placeholder="请选择" @change="stationIdChange">
							<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-col>
				<!-- </el-form> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doUpdate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiListStations
	} from "../charge/charge-equipment";
	import {
		deleteRequest,
		putRequest,
		getRequest,
		postRequest,
	} from "../../utils/api";
	export default {
		name: "OrderList",
		data() {
			return {
				title: "配置推送站点", //模态窗口 标题
				searcheForm: {
					stationIds: null
				}, //搜索
				orderList: [], //列表数据
				rolesOptions: [],
				loading: false,
				dialogVisible: false, // 是否显示 模态窗
				stationIdOptions: [],
				orderForm: {stationIds:new Array()},
			};
		},
		mounted() {
			this.initPageData();
			this.initSelectStations();
		},
		methods: {
			clearForm() {
				this.searcheForm = {};
			},
			doUpdate() {
				const authCode = this.orderForm.destinationAuthCode;
				const name = this.orderForm.name;
				let stations = new Array();
				let stationIds = this.orderForm.stationIds;
				this.stationIdOptions.forEach(station => {
					stationIds.forEach(v => {
						if (v === station.value) {
							const tempStation = {
								stationId: station.value,
								stationName: station.label,
								pushDestinationCode: authCode,
								pushDestinationName: name,
								enabled: "Y"
							}
							stations.push(tempStation);
						}
					})
				})
				postRequest(
					`/api/push-platform/addStation`,
					stations
				).then((resp) => {
					this.dialogVisible = false;
				});
			},
			initSelectStations() {
				apiListStations({
					page: 1,
					size: 9999
				}).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
					}
				});
			},
			stationIdChange(v) {
				this.$forceUpdate()
			},
			//编辑用户按钮
			showSettingDialog(data) {
				this.$forceUpdate()
				this.orderForm = {stationIds:new Array(),...data};
				getRequest(
					`/api/push-platform/list-station/` + data.destinationAuthCode, {}
				).then((resp) => {
					this.loading = false;
					if (resp) {
						let _list = resp.data;
						_list.forEach(e => {
							this.orderForm.stationIds.push(e.stationId)
						})
						this.$forceUpdate()
						this.dialogVisible = true;
					}
				})
				
			},
			// 查询用户列表
			initPageData(type) {
				this.loading = true;
				postRequest(
					`/api/push-platform/list`,
					this.searcheForm
				).then((resp) => {
					this.loading = false;
					if (resp) {
						this.orderList = resp.data;
					}
				});
			}
		},
	};
</script>

<style>
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}
</style>
